export default __webpack_public_path__ + "media/play-btn-2.3aabbfbf.svg";